var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fancy-box-gallery",
      attrs: { itemscope: "", itemtype: "http://schema.org/Thing" },
    },
    [
      _vm.singleImages && _vm.singleImages.length > 0
        ? _c("div", { staticClass: "img-gallery" }, [
            _c(
              "a",
              {
                staticClass: "fancybox d-block",
                staticStyle: { "pointer-events": "none" },
                attrs: {
                  href: _vm.singleImages[0].url,
                  "data-fancybox": "gallery",
                },
              },
              [
                _c("lazy-img", {
                  ref: "itemLazyImage",
                  attrs: {
                    alt: _vm.getAltText(_vm.middleSingleImage[0]),
                    "picture-class": "img-gallery-big-one img-fluid",
                    "image-url": _vm.middleSingleImage[0].url,
                    width: _vm.getImageWidth(_vm.middleSingleImage[0]),
                    height: _vm.getImageHeight(_vm.middleSingleImage[0]),
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.carouselImages.length > 0
        ? _c("div", { staticClass: "thumbs" }, [
            _c(
              "div",
              { staticClass: "thumb-list" },
              [
                _vm._l(_vm.carouselImages, function (imagePreview, index) {
                  return index > 0
                    ? _c("div", { key: index, staticClass: "thumb" }, [
                        _c(
                          "div",
                          {
                            staticClass: "thumb-image",
                            style: {
                              "background-image":
                                "url(" + imagePreview.url + ")",
                            },
                          },
                          [
                            _c("a", {
                              staticClass:
                                "fancybox position-relative d-block h-100",
                              staticStyle: { "pointer-events": "none" },
                              attrs: {
                                href: _vm.singleImages[index].url,
                                "data-fancybox": "gallery",
                              },
                            }),
                          ]
                        ),
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.videoCode
                  ? _c("div", { staticClass: "thumb" }, [
                      _c("div", { staticClass: "thumb-image" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "fancybox position-relative d-block h-100",
                            staticStyle: { "pointer-events": "none" },
                            attrs: {
                              href: _vm.videoUrl,
                              "data-fancybox": "gallery",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-play-circle-o fa-3x",
                            }),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }